import * as $ from 'jquery';
export class adobeDataLayerWrapper {

    push (eventName: String, trackingData: any) {
        if (window.adobeDataLayer) {
            let dataLayer = {
                "event": eventName,
                "_malaysiaairlines":  {
                    "pageName": trackingData.pageName ? trackingData.pageName : null,
                    "pageUrl": location.href,
                    "siteSection": this.getUrlSiteSection('siteSection'),
                    "pageType": trackingData.pageType ? trackingData.pageType: null,
                    "siteName": 'MH.com',
                    "language": this.getUserLanguage(),
                    "market": this.getMarket(),
                    "eventInfo": {
                        "attributes": trackingData.attributes,
                    }
                },
                "web": {
                    "webPageDetails": {
                        "URL": location.href,
                        "name": trackingData.pageName ? trackingData.pageName: null,
                        "server": document.location.hostname, 
                        "siteSection": this.getUrlSiteSection('siteSection'),
                        "siteSubSection": this.getUrlSiteSection('siteSubSection'), 
                        "isErrorPage": "n"
                    }
                }
            }
            if (eventName === 'pageLoaded') {
                dataLayer['_malaysiaairlines']['siteSubSection'] = this.getUrlSiteSection('siteSubSection');
                dataLayer['_malaysiaairlines']['userInfo'] = {
                    "userId": this.getUserID(),
                    "status": this.getUserStatus(),
                };
                dataLayer['_malaysiaairlines']['consent'] = {
                    "c_statistics": true,
                    "c_marketing": true,
                    "c_preference": true,
                };
                dataLayer['web']['webPageDetails']['pageViews'] = {
                    "value": 1
                };
            } else if (eventName === 'click') {
                dataLayer['_malaysiaairlines']['clickInfo'] = {
                    "clickName": trackingData.clickName,
                    "clickComponentType": trackingData.componentType,
                    "componentName": trackingData.componentName,
                    "componentID": trackingData.componentID
                };
                dataLayer['web']['webInteractions'] = {
                    "name": trackingData.clickName,
                    "type": "other",
                    "linkClicks": {
                        "value": 1
                    }
                };
            }
            console.log(dataLayer);
            window.adobeDataLayer.push(dataLayer);
        }
    }
    getUrlSiteSection (urlPart: string) {
        let paramsArr = window.location.pathname.split('/');
        let param = urlPart === 'siteSection' ?  paramsArr[1] : paramsArr[2];
        return param;
    }
    getUserID () {
        let userID = null;
        if (this.getCookie('flyerID')) {
            userID = this.getCookie('flyerID');
            userID = userID.replace(/[a-zA-Z]/g, '');
        }
        return userID;
    }
    getMarket () {
        if (this.getCookie('session-selected-country')) return this.getCookie('session-selected-country').toUpperCase();
        else null;
    }
    getUserLanguage () {
        if (this.getCookie('session-selected-language')) return this.getCookie('session-selected-language');
        else null;
    }
    getUserStatus () {
        let status = 'ambiguous';
        if (this.isSessionExists()) {
            status = 'authenticated';
        } else {
            status = 'loggedOut';
        }
        return status;
    }
    isSessionExists () {
        // check for session and log the event only for once.
        let sapphire = this.getCookie('sapphire');
        return typeof sapphire === 'string';
    }
    getCookie (cookieName :any) {
        var name = cookieName + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookieArray = decodedCookie.split(';');
        for (var i = 0; i < cookieArray.length; i++) {
          var cookie = cookieArray[i];
          while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
          }
          if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
          }
        }
        return "";
    }
    setCookie(cookieName: any, cookieValue: any, expirationDays: any) {
        var date = new Date();
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = cookieName + "=" + cookieValue; + ";" + expires + ";path=/";
    }
}
declare const window: any;
try {
	if (window.adobeDataLayer) {
        window.adobeDataLayer = window.adobeDataLayer || [];
    }
    let errorInUrl = location.href;
    let regex = /error/;
    if (regex.test(errorInUrl)) {
        const adobeDataLayer = new adobeDataLayerWrapper();
        adobeDataLayer.push('pageLoaded', {
            'isErrorPage': 'y'
        })
    }
} catch(e) {console.error(e);}
